import { STATUS_VALUE_ZERO, STATUS_ZERO } from "../../components/attendance/Constants";
import { addTeam } from "../../config/services/employeeServices";
import ResponseFilter from "../../ResponseFilter";
import {
    ADD_TEAM_REQUEST,
    ADD_TEAM_SUCCESS,
    ADD_TEAM_FAILURE,
} from "./actionType";


const addTeamByAdminAction = (props) => {
    let { useDispatch, closeModal, getTeam, obj } = props
    return (dispatch) => {
        dispatch(addTeamByAdminRequest());
        addTeam(obj).then((res) => {
            let { status } = ResponseFilter(res)
            if (status) {
                useDispatch({
                    type: 'typeCheckSet', payload: {
                        resTeamMsg: true,
                        loader: false,
                        successMessage: "Team Added"
                    }
                })
                getTeam()
                closeModal()
                setTimeout(() => useDispatch({
                    type: 'typeCheckSet', payload: {
                        resTeamMsg: false
                    }
                }), 3000);
            } else if (res.data.statusCode === STATUS_VALUE_ZERO) {
                useDispatch({
                    type: 'typeCheckSet', payload: {
                        responseMessage: res.data.error.responseMessage,
                        errorCode: res.data.error.errorCode,
                        resTeamFailMsg: true,
                        loader: false
                    }
                })
                setTimeout(() => useDispatch({
                    type: 'typeCheckSet', payload: {
                        resTeamFailMsg: false
                    }
                }), 3000);
            }
            getTeam()
        })
            .catch((error) => {
                dispatch(addTeamByAdminFailure(error));
                // setErrorText("Failed to add");
                // setFailResMsg(true);
            });
    };
};

const addTeamByAdminRequest = () => {
    return {
        type: ADD_TEAM_REQUEST,
    };
};
const addTeamByAdminSuccess = (data) => {
    return {
        type: ADD_TEAM_SUCCESS,
        payload: data,
    };
};
const addTeamByAdminFailure = (error) => {
    return {
        type: ADD_TEAM_FAILURE,
        payload: error,
    };
};
export {
    addTeamByAdminAction,
    addTeamByAdminRequest,
    addTeamByAdminSuccess,
    addTeamByAdminFailure,
};